module.exports = __webpack_public_path__ + "fonts/Gotham-ThinItalic.bec38ead.otf";